// Like the core-ui component, but autocomplete="off"

import React from 'react';
import { func, bool } from 'prop-types';
import classNames from 'classnames/bind';
import styles from './dropdownsearch.module.scss';

const classes = classNames.bind(styles);

const DropDownSearch = ({ onChange, border }) => {
  const inputClasses = classes([
    'dropdown-search__field',
    { 'dropdown-search__field--border': border }
  ]);
  return (
    <span className={styles['dropdown-search']}>
      <input
        className={inputClasses}
        onChange={(event) => {
          onChange(event.target.value);
        }}
        placeholder="Search"
        type="text"
        autoComplete="off"
      />
    </span>
  );
};

DropDownSearch.displayName = 'DropDownSearch';

DropDownSearch.propTypes = {
  onChange: func,
  border: bool
};

DropDownSearch.defaultProps = {
  onChange: () => {},
  border: true
};

export { DropDownSearch };
